import axios from 'axios';
import * as types from './Reports.types';
import * as selectors from './Reports.selectors';
import * as loginActions from './../Login/Login.actions';
import { showNotification } from './../../utils';
import fileDownload from 'js-file-download';

const apiUrl = process.env.REACT_APP_API_URL;

export const exportReport = () => (dispatch, getState) => {
    const reportType = selectors.getReportType(getState());
    const platform = selectors.getPlatform(getState());
    const coupaOrders = selectors.getCoupaOrders(getState());
    const personalOrders = selectors.getPersonalOrders(getState());
    const managerOrders = selectors.getManagerOrders(getState());
    const startDate = selectors.getStartDate(getState());
    const endDate = selectors.getEndDate(getState());

    let params = [];
    params.push('report-type=' + reportType);
    params.push('platform=' + platform);
    params.push('coupa-orders=' + coupaOrders);
    params.push('personal-orders=' + personalOrders);
    params.push('manager-orders=' + managerOrders);
    params.push('start-date=' + startDate);
    params.push('end-date=' + endDate);

    dispatch({ type: types.EXPORT_REPORT, payload: null });
    axios.get(apiUrl + '/uthealth-order/reports?' + params.join('&'),
        {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` },
            responseType: 'blob',
        })
        .then((response) => {
            dispatch({ type: types.EXPORT_REPORT_SUCCESS, payload: null });
            fileDownload(response.data, 'Report.xlsx');
        })
        .catch((error) => {
            dispatch({ type: types.EXPORT_REPORT_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const setReportType = (value) => dispatch => {
    dispatch({
        type: types.SET_REPORT_TYPE,
        payload: value,
    });
}

export const setPlatform = (value) => dispatch => {
    dispatch({
        type: types.SET_PLATFORM,
        payload: value,
    });
}

export const setOrderType = (name, value) => dispatch => {
    dispatch({
        type: types.SET_ORDER_TYPE,
        payload: { name, value },
    });
}

export const setStartDate = (value) => dispatch => {
    dispatch({
        type: types.SET_START_DATE,
        payload: value,
    });
}

export const setEndDate = (value) => dispatch => {
    dispatch({
        type: types.SET_END_DATE,
        payload: value,
    });
}